import Link from 'next/link';

export default function LibraryNavigation({ onNavigate }: { onNavigate: () => void }) {
  return <div className="border-b border-border py-2">
    <Link href="/library" onClick={onNavigate} className="flex min-h-11 items-center gap-3 rounded-lg px-4 py-2 text-sm text-foreground transition-colors hover:bg-muted-bg">
      <svg aria-hidden="true" className="h-4 w-4 shrink-0 text-muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 5h16v15H4zM8 2v6M4 10h16" strokeLinecap="round" strokeLinejoin="round" /></svg>
      Library
    </Link>
  </div>;
}
